import { selectorFamily } from 'recoil'

import { Change } from '../types'
import stockApi from "../apis/stock";


export const stockState = selectorFamily<Stock, string>({
  key: 'stockState',
  get: (code: string) => async () => {
    return (await stockApi.getRecent(code)).data[0]
  },
})

export interface Stock {
  code: string
  symbolCode: string
  shortCode: string
  market: string
  name: string
  koreanName: string
  parValue: number
  upperLimitPrice: number | null
  lowerLimitPrice: number | null
  previousAccTradeVolume: number
  earningRate: number | null
  highestDay: string | null
  timestamp: number | null
  isActive: boolean
  accTradeVolume: number
  accAskVolume: number
  openingPrice: number
  highPrice: number
  lowPrice: number
  tradePrice: number
  prevClosingPrice: number
  listedShareCount: number // 발행 수
  change: Change
  changePrice: number
  changeRate: number
  preMarketTradeVolume: number // 장 전 거래량
}
